module.exports = __webpack_public_path__ + "static/media/klaasfoppen.7c047970.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/klaasfoppen.webp
// module id = 778
// module chunks = 0